import { Stack } from "@mui/material";
import { type FC } from "react";

import { EventPageSections } from "~/feature/event/constants";
import { NewsCarousel } from "~/feature/news/components/NewsCarousel";
import { NewsFeedSkeleton } from "~/feature/news/components/NewsFeedSkeleton";
import { useEventNews } from "~/feature/news/useEventNews";
import { NewsModeEnum } from "~/types/newsArticle";

interface INewsSectionProps {
  eventId: string;
}

export const NewsSection: FC<INewsSectionProps> = ({ eventId }) => {
  const { feed, isLoading } = useEventNews(eventId);

  if (isLoading) {
    return <NewsFeedSkeleton />;
  }

  if (!feed || feed.mode === NewsModeEnum.EMPTY || !feed.articles.length) {
    return null;
  }

  return (
    <Stack component="section" id={EventPageSections.RelatedNews}>
      <NewsCarousel header={feed.header} articles={feed.articles} />
    </Stack>
  );
};
